import './Registration.css'
import React from 'react'
import RegistrationForm from '../../components/RegistrationForm/RegistrationForm'

function Registration ({onRegister, errorMessage, error}) {

  return (
    <section className="registrationPage">

      <div className='registrationPage__back-up'>
        <div className='registrationPage__back-up-wrapper'>
          <h2 className='registrationPage__title'>Добро пожаловать в сборник  для решения задач 1С</h2>
          <div className='registrationPage__component'>
            <RegistrationForm
              onRegister={onRegister}
              errorMessage={errorMessage}
              error={error}
            />
          </div>
        </div>
      </div>

      <div className='registrationPage__pic'></div>

    </section>
  );
}

export default Registration;